import React from 'react';
import css from "./Calendars.module.css";

const Week = props => (
    <div className={css.week}>{props.children}</div>
);

export default Week;